import Helper from './Helper';
import * as API from './../Constants/api';

class ProjectLoader {
	constructor(config = {}) {
		const { buttonSelector, buttonDataAttribute, maxProjects } = config;

		this.maxProjects = maxProjects || 6;
		this.toggler = document.querySelectorAll(buttonSelector);
		this.togglerArray = Array.prototype.slice.call(this.toggler);
		this.buttonDataAttribute = buttonDataAttribute;
		this.readMoreText = 'weiterlesen';

		if (this.toggler) {
			console.log('projectloader');
			this.bindEvents();
		}
	}

	bindEvents() {
		this.togglerArray.forEach(toggler => {
			toggler.addEventListener('click', e => {
				if (!document.querySelector('.loading-wrapper')) {
					this.createPopup();
					const data = Helper.camelCase(this.buttonDataAttribute);
					const dataValue = toggler.dataset[data];
					this.getProjects(dataValue);
					Helper.addClass(document.body, 'popup-open');
					Helper.addClass(this.popup, 'visible');
				}
			});
		});
	}

	getProjects(employeeID) {
		let APIbase = API.employees;
		let fetchURL = `${APIbase}${employeeID}`;
		//console.log(fetchURL);
		fetch(fetchURL, {
			mode: 'same-origin' // no-cors, cors, *same-origin
		})
			.then(this.handleErrors)
			.then(response => {
				return response.json();
			})
			.then(data => {
				// show 6 max, prefer cases. if not 6 cases yet, fill with stories.
				const projects = data.acf.connection_projects;
				const total = projects.length;

				let casesCount = 0;
				let storiesCount = 0;
				if (total > 0) {
					projects.forEach((project, i) => {
						if (project.post_status == 'publish') {
							if (project.post_type == 'nhs-cases') {
								casesCount = casesCount + 1;
							} else {
								storiesCount = storiesCount + 1;
							}
						}
					});
				}

				//console.log(`casescount is: ${casesCount}`);
				//console.log(`storiescount is: ${storiesCount}`);
				//console.log(`total is: ${total}`);

				let projectLoaded = 0;

				if (casesCount > 0) {
					//console.log('load cases');
					projects.forEach((project, i) => {
						if (projectLoaded < this.maxProjects) {
							if (project.post_status == 'publish') {
								if (project.post_type == 'nhs-cases') {
									this.getPost('case', project.ID);
									projectLoaded = projectLoaded + 1;
								}
							}
						}
					});
				}

				if (total > casesCount && casesCount < this.maxProjects) {
					//console.log('there are stories to load because not enough cases');
					projects.forEach((project, i) => {
						if (projectLoaded < this.maxProjects) {
							if (project.post_status == 'publish') {
								if (project.post_type == 'post') {
									this.getPost('post', project.ID);
									projectLoaded = projectLoaded + 1;
								}
							}
						}
					});
				}
			})
			.catch(err => {
				//console.log(err);
			});
	}

	getPost(type, postID) {
		let fetchURL = `${API.posts}${postID}?_embed`;
		if (type == 'case') {
			fetchURL = `${API.cases}${postID}?_embed`;
		}

		//console.log(fetchURL);
		fetch(fetchURL, {
			mode: 'same-origin' // no-cors, cors, *same-origin
		})
			.then(this.handleErrors)
			.then(response => {
				return response.json();
			})
			.then(data => {
				//console.log(data);
				const post = data;
				const featuredImage =
					post._embedded['wp:featuredmedia']['0'].media_details.sizes.medium
						.source_url;
				const title = post.title.rendered;
				const categories = post._embedded['wp:term'][0];
				const excerpt = post.excerpt.rendered;
				const link = post.link;

				const d = new Date(post.date);
				const day = d
					.getDate()
					.toString()
					.padStart(2, '0');
				const month = (d.getMonth() + 1).toString().padStart(2, '0');
				const year = d.getFullYear();
				const formattedDate = `${day}.${month}.${year}`;
				let backgroundColor = '';

				if (type == 'case') {
					backgroundColor = post.acf.cases_background_color;
				}

				let catString = '';

				categories.forEach(cat => {
					catString += cat.name;
				});

				const className =
					'popup__post popup__post--project';
				document.querySelector(
					'.popup__inner'
				).innerHTML += this.fillTemplate(
					formattedDate,
					catString,
					link,
					featuredImage,
					title,
					excerpt,
					className,
					backgroundColor
				);
				Helper.addClass(
					document.querySelector(`.popup .loading-wrapper`),
					'hidden'
				);
				Helper.addClass(
					document.querySelector(`.popup .popup__title`),
					'visible'
				);
			})
			.catch(err => {
				//console.log(err);
			});
	}

	createPopup() {
		if (this.popup != undefined) {
		} else {
			var elem = document.createElement('div');
			Helper.addClass(elem, 'project-popup');
			Helper.addClass(elem, 'popup');
			elem.innerHTML =
				'<div class="popup__close"><span class="popup__close-icon"></span><span class="popup__closer">Schliessen</span></div>';
			document.body.appendChild(elem);
			elem.innerHTML += `<div class="popup__title">Da habe ich mitgearbeitet:</div>`;
			elem.innerHTML += `<div class="loading-wrapper"><div class="loading-wrapper__spinner"></div></div><div class="popup__content"><div class="popup__inner"></div></div>`;
			this.popup = document.querySelector('.project-popup');
		}

		document.body.addEventListener('keyup', e => {
			if (e.keyCode == 27) {
				// //console.log('esc');
				this.killPopup();
			}
		});

		document
			.querySelector('.popup .popup__close')
			.addEventListener('click', e => {
				this.killPopup();
			});
	}

	killPopup() {
		this.popup.innerHTML = '';
		this.popup.remove();
		this.popup = undefined;
		Helper.removeClass(document.body, 'popup-open');
	}

	fillTemplate(
		formattedDate,
		catString,
		link,
		featuredImage,
		title,
		excerpt,
		className,
		backgroundColor
	) {
		let $bgClass = '';
		if (backgroundColor != '') {
			$bgClass = `post-list__link-image--${backgroundColor}`;
		}
		return `
		<article class="${className}">
		<a class="popup__link" href="${link}">
			<div class="post-list__meta">
				<span class="post-list__date">${formattedDate}</span>
				<span class="post-list__category">${catString}</span>
			</div>
			<div class="post-list__image">
				<span class="post-list__link-image ${$bgClass}">
					<img src="${featuredImage}">
				</span>
			</div>
			<div class="post-list__content">
				<h2 class="post-list__title">
					${title}
				</h2>
				<div class="post-list__excerpt">
					<p>${excerpt}</p>
				</div>
				<span class="post-list__link nhs-btn nhs-arrow-btn">
					<span class="nhs-arrow-btn__arrow nhs-arrow-btn__arrow--left">
						<span class="nhs-arrow-btn__shaft"></span>
					</span>
					<span class="nhs-arrow-btn__main">
						<span class="nhs-arrow-btn__text">${this.readMoreText}</span>
						<span class="nhs-arrow-btn__arrow nhs-arrow-btn__arrow--right">
							<span class="nhs-arrow-btn__shaft"></span>
						</span>
					</span>
				</span>
			</div>
		</a>
		</article>`;
	}
}
export default ProjectLoader;
